<script setup lang="ts">
interface PropertyPhoto {
	watermarkUrl: string;
	url?: string;
}

interface ImageProps {
	preload?: boolean;
	fetchpriority?: 'high' | 'auto';
	decoding?: 'async';
	loading?: 'eager' | 'lazy';
}

interface PropertyPhotoCarouselSingleItemDeprecatedProps {
	photo: PropertyPhoto;
	photoIndex: number;
	isLoading?: boolean;
	altText: string;
	imageProps?: ImageProps;
}

const props = withDefaults(
	defineProps<PropertyPhotoCarouselSingleItemDeprecatedProps>(),
	{
		isLoading: false,
		imageProps: () => ({
			preload: false,
			fetchpriority: 'auto',
			decoding: 'async',
			loading: 'lazy'
		})
	}
);

const emit = defineEmits<{
	'photo-clicked': [photoIndex: number, photoUrl: string];
}>();

function handlePhotoClick() {
	emit('photo-clicked', props.photoIndex, props.photo.watermarkUrl);
}
</script>

<template>
	<div class="relative size-full overflow-hidden">
		<Skeleton :is-active="isLoading" class="size-full" variant="white">
			<NuxtImg
				:src="photo.watermarkUrl"
				:alt="altText"
				width="960"
				height="500"
				sizes="lg:640px xl:800px 2xl:960px"
				densities="x1"
				:preload="imageProps.preload ? { fetchPriority: 'high' } : undefined"
				:decoding="imageProps.decoding"
				:loading="imageProps.loading"
				class="size-full cursor-pointer object-cover object-center"
				format="webp"
				quality="80"
				@click="handlePhotoClick"
			/>
		</Skeleton>
	</div>
</template>
